// Display labels and colors of the maintenance module (through t(), dashboard namespace).

export const typeLabels = t => ({
  heating_gas: t("Gas heating"),
  heating_oil: t("Oil heating"),
  heat_pump: t("Heat pump"),
  electrical_installation: t("Electrical installation"),
  portable_device: t("Portable device (DGUV V3)"),
  smoke_detector: t("Smoke detector"),
  ventilation: t("Ventilation"),
  roof: t("Roof"),
  fire_protection: t("Fire protection"),
  other: t("Other")
});

export const visitStatusLabels = t => ({
  planned: t("Planned"),
  in_progress: t("In progress"),
  completed: t("Completed"),
  cancelled: t("Cancelled")
});

export const VISIT_STATUS_COLORS = {
  planned: "default",
  in_progress: "processing",
  completed: "success",
  cancelled: "default"
};

export const contractStatusLabels = t => ({
  draft: t("Draft"),
  active: t("Active"),
  terminated: t("Terminated"),
  ended: t("Ended")
});

export const CONTRACT_STATUS_COLORS = {
  draft: "default",
  active: "success",
  terminated: "warning",
  ended: "default"
};

export const billingLabels = t => ({
  open: t("To invoice"),
  covered: t("Covered by flat fee"),
  invoiced: t("Invoiced"),
  none: t("Nothing to invoice")
});

export const dueLabels = t => ({
  overdue: t("Overdue"),
  due: t("Due soon"),
  upcoming: t("Upcoming"),
  none: t("No date")
});

export const DUE_COLORS = {
  overdue: "error",
  due: "warning",
  upcoming: "default",
  none: "default"
};

export const resultLabels = t => ({
  pass: t("Passed"),
  fail: t("Defects found"),
  incomplete: t("Incomplete")
});

export const RESULT_COLORS = { pass: "success", fail: "error", incomplete: "warning" };

export const intervalLabels = t => ({
  monthly: t("Monthly"),
  quarterly: t("Quarterly"),
  half_yearly: t("Half-yearly"),
  yearly: t("Yearly")
});
